import Carousel from './components/Carousel';
import Checklist from './components/Checklist';
import Scrolly from './components/Scrolly';
import Accordion from './components/Accordion';
import Tabs from './components/Tabs';
import Header from './components/Header';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Accordion,
      Carousel,
      Header,
      Checklist,
      Scrolly,
      Tabs,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
